module.exports = __webpack_public_path__ + "img/achievement_30.a85a86b1.png";